import dayjs from 'dayjs';
import { FC } from 'react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/subscription-detail/shipping-product-list.module.css';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';
import { ProductItem } from './ProductItem';
import { ProductBlankItem } from './ProductBlankItem';
import { MessageContentViewType } from '../../types/view/message-content-view-type';
import { OverrideUrlItemType } from '../../types/view/postmessage-type';
import { Summary } from '../../hooks/use-subscription-summary';

export const ShippingProductList: FC<{
  summary?: Summary;
  products: ProductInfoViewType[];
  overrideUrlItems?: OverrideUrlItemType[];
  loading: boolean;
  cancelSubscriptionFunc: (lineId?: string) => void;
  updateQuantityFunc: (lineId: string, quantity: number) => void;
  setChangeDeliveryDateModalFunc: (changeDeliveryDateModalActive: boolean) => void;
  setMessageModalActive: (modalActive: boolean) => void;
  setMessageContent: (messageContent: MessageContentViewType) => void;
}> = ({ 
  summary,
  products,
  overrideUrlItems,
  loading,
  cancelSubscriptionFunc,
  updateQuantityFunc,
  setChangeDeliveryDateModalFunc,
  setMessageModalActive,
  setMessageContent
}) => {

  const totalPriceBlock = summary ? (
    <span className={classes.productTable_content_totalPrice_heading_current}>
      ￥<NumberFormat displayType="text" value={summary.totalPrice} thousandSeparator={true} />
    </span>
  ) : (
    // summary.totalOriginalPrice === summary.totalPrice ? (
    //   <>
    //     <span className={classes.productTable_content_totalPrice_heading_current}>
    //       ￥<NumberFormat displayType="text" value={summary.totalPrice} thousandSeparator={true} />
    //     </span>
    //   </>
    // ) : (
    //   <>
    //     <span className={classes.productTable_content_totalPrice_heading_original}>
    //       ￥<NumberFormat displayType="text" value={summary.totalOriginalPrice} thousandSeparator={true} />
    //     </span>
    //     <span className={classes.productTable_content_totalPrice_heading_arrow}>→</span>
    //     <span className={classes.productTable_content_totalPrice_heading_current}>
    //       ￥<NumberFormat displayType="text" value={summary.totalPrice} thousandSeparator={true} />
    //     </span>
    //   </>
    // )
    <></>
  );

  const targetDeliveryTime = summary && summary.enableDeliveryTimes.find((deltime) => deltime.selected);
  const deliveryTimeLabel = targetDeliveryTime ? <>{targetDeliveryTime.label}</> : <></>;

  return (
    <div className={classes.table}>
      <ul className={classes.table_list}>
        <li key="table_item_shipping" className={classes.table_item}>
          <div className={classes.shipping_title}>
            <h4 className={classes.shipping_title_heading}>お届け予定日</h4>
          </div>
          <div className={classes.shipping_content}>
            <div className={classes.shipping_summary}>
              <p className={classes.shipping_summary_date}>
                {summary ? dayjs(summary.nextDeliveryDate).format('YYYY年 M月DD日（ddd）') : ''}
              </p>
              <p className={classes.shipping_summary_time}>時間帯：{deliveryTimeLabel}</p>
            </div>

            <div className={classes.shipping_action}>
              <button className={classes.shipping_action_btn} onClick={() => setChangeDeliveryDateModalFunc(true)}>
                変更
              </button>
            </div>
          </div>
        </li>

        <li key="table_item_product" className={classes.table_item}>
          <div className={classes.productTable_title}>
            <h4 className={classes.productTable_title_heading}>お届け予定商品</h4>
          </div>
          <div className={classes.productTable_content}>
            <div className={classes.productTable_content_totalPrice}>
              <h4 className={classes.productTable_content_totalPrice_heading}>
                <span className={classes.productTable_content_totalPrice_heading_prefix}>合計金額(税込)：</span>
                {totalPriceBlock}
              </h4>
            </div>
            <div className={classes.productTable_content_products}>
              <ul className={classes.productTable_content_products_list}>
                {
                  products.length === 0 ?
                    <ProductBlankItem/> :
                    products.map((product, index) => {
                      let overrideUrl = '';
                      if (overrideUrlItems) {
                        const filtered = overrideUrlItems.filter(item => `gid://shopify/ProductVariant/${String(item.variantId)}` === product.variantId);
                        overrideUrl = filtered.length > 0 ? filtered[0].url : '';
                      }
                      return (
                        <ProductItem
                          key={`productItem_${index}`}
                          loading={loading}
                          productItem={product}
                          overrideUrl={overrideUrl}
                          cancelSubscriptionFunc={cancelSubscriptionFunc}
                          updateQuantityFunc={updateQuantityFunc}
                          setMessageModalActive={setMessageModalActive}
                          setMessageContent={setMessageContent}
                        />
                      )
                    })
                }
              </ul>

              <div className={classes.productTable_content_actions}>
                <Link to="/pickup" className={classes.productTable_content_actions_btn}>
                  商品一覧　&gt;
                </Link>
                <p className={classes.productTable_content_actions_note}>
                  ※お届け情報（お届け日・お届け商品）は翌月の配送予定に引き継がれます。
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};
